@if (emptyContainer && photoContainer?.children?.length > 0) {
  <div
    [class]="emptyContainer.uId"
    [item]="emptyContainer"
    app-block
    [attr.tabindex]="emptyContainer.tabindex"
  ></div>
}

@if (settings.showBigPhoto) {
  <div [class]="mainPhotoContainer.uId">
    <div [class]="photoContainer.uId">
      @for (photo of photoContainer.children; track photo; let i = $index) {
        <div
          (click)="openFullScreenPreview(i)"
          [ngClass]="blockClasses(photo)"
          [hidden]="mainPhotoIndex != i"
        >
          @if (descrptionsEnabled && photo.children.length) {
            @for (child of photo.children; track child) {
              @if (child.settings.viewPart === viewPart.MAIN_PHOTO_BLOCK) {
                <!--
                  Przy włączonych opisach rodzicem jest bezstylowy kontener wstawiany przez
                  backend, więc styl zdjęcia może wylądować tylko tutaj. Klasę `m<modelId>`,
                  drugą połowę selektora, dokłada BlockComponent.
                -->
                <div
                  [class]="child.uId"
                  [item]="child"
                  app-block
                  class="photo"
                  [attr.tabindex]="photo.tabindex || child.tabindex"
                ></div>
              } @else {
                <div
                  [class]="child.uId"
                  [item]="child"
                  app-block
                  [attr.tabindex]="photo.tabindex"
                ></div>
              }
            }
          } @else {
            <div
              [item]="photo"
              app-block
              [attr.tabindex]="photo.tabindex"
              class="photo"
            ></div>
          }
        </div>
      }
    </div>
  </div>
}

@if (settings.showThumbnails && thumbnailsContainer) {
  <div [class]="thumbnailsContainer.uId">
    <div
      [ngClass]="[
      'm' + (thumbnailsSubContainer.modelId?.toString() ?? ''),
      thumbnailsSubContainer.uId?.toString() ?? ''
    ]"
    >
      @if (thumbnailsSubContainer.descrptionsEnabled) {
        @for (thumbnail of thumbnailsSubContainer.children; track thumbnail; let i = $index) {
          <div
            (click)="openFullScreenPreview(i)"
            (mouseover)="previewInMainPhoto(i)"
            [class]="thumbnail.uId"
            class="thumbnail"
            [ngStyle]="thumbnailStyle"
          >
            <div class="thumbnail-wrapper">
              @for (thumbnailChild of thumbnail.children; track thumbnailChild) {
                <div
                  [class]="thumbnailChild.uId"
                  [item]="thumbnailChild"
                  app-block
                  (keydown.enter)="openFullScreenPreview(i)"
                  (focus)="previewInMainPhoto(i)"
                  [attr.tabindex]="thumbnailChild.tabindex"
                ></div>
              }
            </div>
          </div>
        }
      } @else {
        <!-- legacy mode -->
        @for (thumbnail of thumbnailsSubContainer.children; track thumbnail; let i = $index) {
          <div
            (click)="openFullScreenPreview(i)"
            (mouseover)="previewInMainPhoto(i)"
            [class]="thumbnail.uId"
            [item]="thumbnail"
            class="thumbnail"
            app-block
            [attr.tabindex]="thumbnail.tabindex"
          ></div>
        }
      }
    </div>
  </div>
}
